<template>
    <div>
      <keep-alive>
          <router-view v-if="$route.meta.keepAlive"></router-view>
      </keep-alive>
      <router-view v-if="!$route.meta.keepAlive"/>
    </div>
</template>

<script>
  export default {
    name: 'home'
  }
</script>

<style scoped>

</style>
